import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import { toast } from "sonner";
import { isNative } from "./native";

// Native: opens the device camera and feeds the shot into the given hidden <input type=file>'s onChange.
// Web: falls back to clicking the input.
export async function openCamera(inputRef, source = CameraSource.Camera) {
  const input = inputRef.current;
  if (!input) return;
  if (!isNative()) { input.click(); return; }
  try {
    const photo = await Camera.getPhoto({
      source, resultType: CameraResultType.Uri,
      quality: 80, width: 2048, correctOrientation: true, saveToGallery: false,
    });
    const blob = await (await fetch(photo.webPath)).blob();
    const ext = photo.format || "jpeg";
    const file = new File([blob], `photo_${Date.now()}.${ext}`, { type: blob.type || `image/${ext}` });
    const dt = new DataTransfer();
    dt.items.add(file);
    input.files = dt.files;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  } catch (e) {
    if (!/cancel/i.test(e?.message || "")) toast.error("Camera unavailable. Check camera permission in Settings.");
  }
}

// System photo picker (Android Photo Picker / iOS PHPicker): no broad media permission needed.
export const openPhotoPicker = (inputRef) => openCamera(inputRef, CameraSource.Photos);
